import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";


import { Select } from "../../components/Core";



const CTA = () => {
  return (
    <>
      {/* <!-- CTA Area --> */}
      <div className="cta-section overflow-hidden py-13 py-lg-25 bg-mirage bg-pattern pattern-1 " id="cta-prev">
        <Container>
          <Row className="align-items-center">
            <Col xl="5" md="6" data-aos="fade-right" data-aos-duration="800">
              <div className="section-title pr-lg-7 mb-0 dark-mode-texts">
                <div className="chat-icon circle-xl gr-bg-white-opacity-1 text-green gr-text-4 mb-13">
                  <i className="icon icon-chat-round-2 text-green"></i>
                </div>
                <h2 className="title gr-text-4 mb-6">
                  ¿Tienes preguntas? ¡Te llamamos!
                </h2>
                <p className="gr-text-8 pr-lg-7 mb-0">
                  Estamos encantados de entender tus necesidades y ver cómo podemos ayudar
                   a tu empresa o evento. Déjanos tus datos y te contactamos! 
                </p>
              </div>
            </Col>
            <Col
              xl="4"
              lg="5"
              md="6"
              className="offset-xl-3 offset-lg-1 mt-9 mt-md-0"
              data-aos="fade-left"
              data-aos-duration="800"
            >
              <form className="cta-form bg-white light-mode rounded-10 px-8 py-8"
               name="contact-prev"
               method="post"
               data-netlify="true"
               data-netlify-honeypot="bot-field">
                 <input type="hidden" name="form-name" value="contact-prev" />
                <div className="form-group gr-text-11 font-weight-bold text-blackish-blue">
                  <label htmlFor="ctaName">Nombre completo </label>
                  <input
                    type="text"
                    className="form-control gr-text-11"
                    id="ctaName"
                    name="Name"
                    placeholder="i.e. Jaime Sanchez"
                    required=""
                  />
                </div>
                <div className="form-group gr-text-11 font-weight-bold text-blackish-blue">
                  <label htmlFor="ctaEmail">Email </label>
                  <input
                    type="phone"
                    className="form-control gr-text-11"
                    id="ctaEmail"
                    name="Email"
                    placeholder="i.e. jaime@mail.com"
                    required=""
                  />
                </div>
                <div className="form-group gr-text-11 font-weight-bold text-blackish-blue">
                  <label htmlFor="ctaPhone">Teléfono </label>
                  <input
                    type="text"
                    className="form-control gr-text-11"
                    id="ctaPhone"
                    name="Phone"
                    placeholder="i.e. 123-456-7890"
                  />
                </div>
                <div className="form-group gr-text-11 font-weight-bold text-blackish-blue">
                  <label htmlFor="ctaMessage" className="pr-lg-4">
                   ¿Cómo podemos ayudarte?{" "}
                  </label>

                  <textarea
                        id="ctaMessage"
                        name="Message"
                        className="form-control px-7 gr-text-11 border"
                        placeholder="Tengo una consulta acerca de..."
                        required
                      ></textarea>
                  
                </div>
                <Button type="submit" className="gr-hover-y rounded-8 w-100">
                  Enviar
                </Button>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CTA;
